import React from 'react';
import { cn } from '@/lib/utils';

interface TabItem {
  id: string;
  label: string;
  count?: number;
}

interface TabControlProps {
  tabs: TabItem[];
  activeTab: string;
  onChange: (id: string) => void;
}

const TabControl = ({ tabs, activeTab, onChange }: TabControlProps) => {
  return (
    <div className="w-full flex flex-row gap-3 bg-db-wrap border border-db-border rounded-full p-1">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onChange(tab.id)}
          className={cn(
            'title2medium cursor-pointer rounded-full flex-1 p-2 transition-colors ',
            activeTab === tab.id ? 'bg-[#007AFF] text-white' : 'bg-transparent text-db-text'
          )}
        >
          <span>
            {tab.label.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}
            {tab.count !== undefined && ` (${tab.count})`}
          </span>
        </button>
      ))}
    </div>
  );
};

export default TabControl;
